import { createStore } from '@oneappexchange/lwc-wired';
import { IS_DEVELOPMENT } from '~/config';
import { logger } from '../../utilities/logger';
const initialState = {
  notifications: [],
  id: 0
};
export const notificationsStore = createStore(initialState, (set, get) => ({
  reset() {
    set(function reset() {
      return initialState;
    });
  },
  addNotification(message, type, action) {
    set(function addNotification(draft) {
      if (draft.notifications.length === 0 || !notificationAlreadyExists(message, type, action, draft.notifications)) {
        draft.id++;
        draft.notifications.push({
          id: draft.id,
          message: message,
          type: type,
          action: action
        });
      } else {
        logger.warn(`Attempted to insert duplicate notification: message=${message}, type=${type}, action=${action}`);
      }
    });
    return get().id;
  },
  removeNotification(id) {
    set(function removeNotification(draft) {
      for (let i = 0; i < draft.notifications.length; i++) {
        if (draft.notifications[i].id === id) {
          draft.notifications.splice(i, 1);
        }
      }
    });
  }
}), 'NOTIFICATIONS', IS_DEVELOPMENT);
export function getNumberOfNotifications(state) {
  return state.notifications ? state.notifications.length : 0;
}
export function selectNotifications(state) {
  return state.notifications;
}
function notificationAlreadyExists(newMessage, newType, newAction, notifications) {
  return notifications.some(({
    message,
    type,
    action
  }) => message === newMessage && type === newType && (action === null || action === void 0 ? void 0 : action.href) === (newAction === null || newAction === void 0 ? void 0 : newAction.href) && (action === null || action === void 0 ? void 0 : action.name) === (newAction === null || newAction === void 0 ? void 0 : newAction.name));
}